export const ALL_EVENTS_VIEW = "/events"
